import { PlayerAchievement } from '../types';

export const ALL_ACHIEVEMENTS: PlayerAchievement[] = [
  {
    id: 'ach_first_goal',
    code: 'first_goal',
    title: 'First Goal',
    description: 'Scored your first official goal in GigaBalls FC',
    icon: '⚽',
    category: 'goals'
  },
  {
    id: 'ach_hattrick',
    code: 'hattrick_hero',
    title: 'Hat-Trick Hero',
    description: 'Scored 3 or more goals in a single match',
    icon: '🔥',
    category: 'goals'
  },
  {
    id: 'ach_10_goals',
    code: 'goals_10',
    title: '10 Goals Club',
    description: 'Reached 10 career goals',
    icon: '🥇',
    category: 'goals'
  },
  {
    id: 'ach_25_goals',
    code: 'goals_25',
    title: '25 Goals Master',
    description: 'Reached 25 career goals',
    icon: '👑',
    category: 'goals'
  },
  {
    id: 'ach_assist_king',
    code: 'assist_king',
    title: 'Assist King',
    description: 'Recorded 10 or more career assists',
    icon: '🎯',
    category: 'assists'
  },
  {
    id: 'ach_5_motm',
    code: 'motm_5',
    title: '5x MOTM Star',
    description: 'Voted Man of the Match 5 times',
    icon: '⭐',
    category: 'motm'
  },
  {
    id: 'ach_win_streak',
    code: 'win_streak_5',
    title: '5 Win Streak',
    description: 'Won 5 consecutive matches in a row',
    icon: '⚡',
    category: 'special'
  },
  {
    id: 'ach_clean_sheet',
    code: 'clean_sheet_king',
    title: 'Clean Sheet Wall',
    description: 'Kept a clean sheet as GK or defender',
    icon: '🛡️',
    category: 'special'
  },
  {
    id: 'ach_10_apps',
    code: 'apps_10',
    title: '10 Appearances',
    description: 'Played in 10 group matches',
    icon: '👕',
    category: 'attendance'
  }
];
